import React from 'react';
import { motion } from 'framer-motion';
import { Shield, CheckSquare, Calendar, MessageSquare, ClipboardList, Sparkles, Brain, Heart, Zap, User } from 'lucide-react';
export function MechanismSection() {
  const layers = [{
    icon: Brain,
    title: 'Intuición',
    desc: 'El salto cognitivo que los datos no pueden dar.'
  }, {
    icon: Heart,
    title: 'Ética',
    desc: 'El filtro moral que protege a la marca.'
  }, {
    icon: Zap,
    title: 'Caos Creativo',
    desc: 'La conexión de ideas aparentemente inconexas.'
  }, {
    icon: User,
    title: 'Presencia',
    desc: 'El peso humano en la negociación y liderazgo.'
  }];
  const deliverables = [{
    icon: Shield,
    text: 'El Anti-Manual de la IA (Guía Maestra en PDF).'
  }, {
    icon: CheckSquare,
    text: 'Matriz de Irreemplazabilidad: Para auditar qué parte de tu día te pone en riesgo.'
  }, {
    icon: Calendar,
    text: 'El Puente de 21 Días: Plan de acción diario para reprogramar tu valor percibido.'
  }, {
    icon: MessageSquare,
    text: 'Guiones de Negociación "High-Touch" para clientes y jefes.'
  }, {
    icon: ClipboardList,
    text: 'Checklist de Diagnóstico de Obsolescencia.'
  }, {
    icon: Sparkles,
    text: 'Bonus: 5 Prompts de Soberanía para que la IA trabaje para ti y no al revés.'
  }];
  return <section className="py-20 px-4 bg-navy-900/20 border-t border-gold-500/10" data-id="element-199">
      <div className="max-w-5xl mx-auto" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-20" data-id="element-201">
          <h2 className="text-3xl md:text-4xl font-serif text-gold-500 mb-6 text-center" data-id="element-202">
            El Protocolo de Blindaje Humano
          </h2>
          <p className="text-lg text-gray-300 text-center max-w-3xl mx-auto mb-12" data-id="element-203">
            Este no es un curso técnico de IA. Es una estrategia de reubicación
            identitaria. Consiste en identificar y potenciar las 4 capas de
            valor heurístico que son físicamente imposibles de replicar para un
            código binario. Pasas de ser un "ejecutor automatizable" a ser el
            "Artesano Estratégico" que la empresa no puede permitirse perder.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-204">
            {layers.map((layer, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-dark-800 p-6 rounded-lg border border-gold-500/20 text-center hover:border-gold-500/50 transition-colors" data-id="element-205">
                <layer.icon className="w-10 h-10 text-gold-500 mx-auto mb-4" data-id="element-206" />
                <h4 className="text-xl font-serif text-white mb-2" data-id="element-207">
                  {layer.title}
                </h4>
                <p className="text-sm text-gray-400" data-id="element-208">{layer.desc}</p>
              </motion.div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-dark-800 rounded-2xl p-8 md:p-12 border border-gold-500/20" data-id="element-209">
          <h3 className="text-2xl md:text-3xl font-serif text-white mb-10 text-center" data-id="element-210">
            Lo que obtienes hoy
          </h3>

          <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-211">
            <div className="w-full md:w-1/2" data-id="element-212">
              <img src="https://cdn.magicpatterns.com/uploads/cHem7FeV8hPwLg8VRhTGRT/ChatGPT_Image_17_abr_2026,_12_46_32.png" alt="Contenido del Anti-Manual" className="w-full rounded-lg shadow-xl shadow-gold-500/5" data-id="element-213" />
            </div>
            <div className="w-full md:w-1/2 space-y-6" data-id="element-214">
              {deliverables.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex items-start space-x-4" data-id="element-215">
                  <item.icon className="w-6 h-6 text-gold-500 flex-shrink-0 mt-1" data-id="element-216" />
                  <p className="text-gray-300" data-id="element-217">{item.text}</p>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}